



























































































































































import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import GenericFileUploader from '../../../components/uploader/GenericFileUploader.vue';
import {
  CreateGripBarrierBase,
  GripBarrierDTO,
  LinkDTO,
  UpdateGripBarrierPayload,
} from '../../../store/types/grip.types';
import DomainCategoryDropdown from '../DomainCategory/DomainCategoryDropdown.vue';
// import InteractiveModal from '@/components/base/InteractiveModal.vue';
import InteractiveModal from '../../../components/base/InteractiveModal.vue';
import GripModalMixin from '@/views/Grip/components/grip-modal.mixin';

@Component({
  components: { DomainCategoryDropdown, GenericFileUploader, InteractiveModal },
})
export default class BarrierModal extends mixins(GripModalMixin) {
  @Prop() public gripBarrierDetails!: GripBarrierDTO;

  /**
   * Fulfills the contract of the GripModalMixin by providing the `itemDetails` property.
   * This computed property maps the component-specific `gripBarrierDetails` prop
   * to the generic `itemDetails` property that the mixin expects.
   */
  public get itemDetails(): GripBarrierDTO | null {
    return this.gripBarrierDetails;
  }

  public dirtyItem: CreateGripBarrierBase = {
    title: '',
    description: '',
    action: true,
    reason: '',
    links: [],
    attachments: [],
    gripDomainCategoryId: null,
  };
  public itemLinks: LinkDTO[] = [];

  public errorMessage: {
    title: string | null;
    description: string | null;
    reason: string | null;
  } = { title: null, description: null, reason: null };

  public validateData() {
    if (!this.dirtyItem.title.trim().length) {
      this.errorMessage.title = 'This Field is Required';
    } else {
      this.errorMessage.title = null;
    }

    if (
      this.dirtyItem.description &&
      this.wordCount(this.dirtyItem.description.trim()) > 150
    ) {
      this.errorMessage.description = 'Max 150 words are allowed.';
    } else {
      this.errorMessage.description = null;
    }

    if (!this.dirtyItem.action) {
      if (this.dirtyItem.reason && this.dirtyItem.reason.trim().length) {
        if (
          this.dirtyItem.reason &&
          this.wordCount(this.dirtyItem.reason.trim()) <= 50
        ) {
          this.errorMessage.reason = null;
        } else {
          this.errorMessage.reason = 'Max 50 words are allowed.';
        }
      } else {
        this.errorMessage.reason = 'This Field is Required';
      }
    } else {
      this.errorMessage.reason = null;
    }
    return this.errorMessage;
  }

  public onAddGripBarrier(): void {
    this.validateData();
    if (
      !this.errorMessage.title &&
      !this.errorMessage.description &&
      !this.errorMessage.reason &&
      this.areLinksValid
    ) {
      this.getGripItemLinks();
      this.getItemAttachments();
      this.dirtyItem.gripDomainCategoryId = this.selectedGripDomainCategoryId;
      this.$emit('create', this.dirtyItem);
    }
  }

  public onUpdateGripBarrier(): void {
    this.getGripItemLinks();
    this.getItemAttachments();
    this.dirtyItem.gripDomainCategoryId = this.selectedGripDomainCategoryId;
    const barrier: { [key: string]: any } = { ...this.dirtyItem };
    const barrierInfo: { [key: string]: any } = {
      ...this.gripBarrierDetails,
    };

    let updateBarrier: UpdateGripBarrierPayload | any = {};
    Object.keys(barrier).forEach((key: string) => {
      if (key === 'gripDomainCategoryId') {
        if (barrierInfo.gripDomainCategory) {
          if (
            JSON.stringify(barrier.gripDomainCategoryId) !==
            JSON.stringify(barrierInfo.gripDomainCategory.id)
          ) {
            updateBarrier.gripDomainCategoryId = barrier.gripDomainCategoryId;
          }
        } else if (
          barrierInfo.gripDomainCategory !== barrier.gripDomainCategoryId
        ) {
          updateBarrier.gripDomainCategoryId = barrier.gripDomainCategoryId;
        }
      } else {
        if (JSON.stringify(barrier[key]) !== JSON.stringify(barrierInfo[key])) {
          updateBarrier = {
            ...updateBarrier,
            [key]: barrier[key],
          };
        }
      }
    });
    this.validateData();
    if (
      !this.errorMessage.title &&
      !this.errorMessage.description &&
      !this.errorMessage.reason &&
      this.areLinksValid
    ) {
      /**
       * If validation passes, always emit 'update'.
       * 'updateBarrier' will be an empty object if no actual changes were made
       */
      this.$emit('update', {
        id: this.gripBarrierDetails.id,
        ...updateBarrier,
      });
    }
  }

  public mounted(): void {
    this.isDomainCategoriesLoading = true;
    this.getGripDomainCategories(this.projectId);
    if (
      this.gripBarrierDetails &&
      Object.keys(this.gripBarrierDetails).length > 0
    ) {
      const {
        gripDomainCategory,
        id,
        ...barrierInfo
      } = this.gripBarrierDetails;
      barrierInfo.links.forEach((link: string) => {
        this.count++;
        this.itemLinks.push({
          url: link,
          count: this.count,
          isValid: true,
          errorMessage: '',
        });
      });

      barrierInfo.attachments.forEach((file) => {
        const fileData = file.split('/');
        this.fileAttachment.push({
          type: file,
          name: fileData[fileData.length - 1],
        });
      });

      this.selectedGripDomainCategoryId = gripDomainCategory
        ? gripDomainCategory.id
        : null;

      this.dirtyItem = {
        ...barrierInfo,
        gripDomainCategoryId: this.selectedGripDomainCategoryId,
      };
    }

    this.setInitialFormState();
  }
}
